<div class="filter-sidebar" [class.open]="isOpen">
  <div class="filter-header">
    <span class="filter-heading">Filters</span>

    <app-exit-button ariaLabel="Close filter" (clicked)="closeFilter()"></app-exit-button>
  </div>

  <!-- Date picker dropdown -->
  <div class="filter-section">
    <span class="section-heading">Date</span>

    <!-- Visible combined field -->
    <div class="date-range-display" (click)="openDatePicker()">
      <img class="icon" src="assets/home/filter/dates_logo.svg" />
      <span class="label">Dates Range</span>
      <span class="value">
        {{ startDate | date : "d/M/yy" }} - {{ endDate | date : "d/M/yy" }}
      </span>
      <span class="expand-icon">↕</span>
    </div>

    <!-- Hidden native inputs -->
    <input #startInput type="date" class="hidden-date" [(ngModel)]="startDate" (change)="onStartSelected()" />

    <input #endInput type="date" class="hidden-date" [(ngModel)]="endDate" (change)="onEndSelected()" />
  </div>

  <div class="filter-section">
    <span class="section-heading">Waypoints</span>
    <div class="waypoints-list">
      <div class="waypoint-item" *ngFor="let item of waypoints">
        <input type="checkbox" [id]="item.id" [(ngModel)]="item.checked" />
        <label [for]="item.id">
          <img [src]="item.icon" class="waypoint-icon" />
          {{ item.label }}
        </label>
      </div>
    </div>
  </div>
</div>